import { darken, getContrastRatio, lighten } from "@material-ui/core/styles/colorManipulator";
import { dark, light, PaletteColorOptions } from "@material-ui/core/styles/createPalette";

const _tonalOffset = 0.2;
const _contrastThreshold = 3;

function getContrastText(background) {
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    const contrastText =
        getContrastRatio(background, dark.text.primary) >= _contrastThreshold ? dark.text.primary : light.text.primary;

    return contrastText;
}

function addLightOrDark(intent, direction, shade, tonalOffset) {
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) {
            intent[direction] = intent[shade];
        } else if (direction === "light") {
            intent.light = lighten(intent.main, tonalOffset);
        } else if (direction === "dark") {
            intent.dark = darken(intent.main, tonalOffset * 1.5);
        }
    }
}

function augmentColor(color, mainShade = 500, lightShade = 300, darkShade = 700) {
    if (!color.main && color[mainShade]) {
        color.main = color[mainShade];
    }

    addLightOrDark(color, "light", lightShade, _tonalOffset);
    addLightOrDark(color, "dark", darkShade, _tonalOffset);
    if (!color.contrastText) {
        color.contrastText = getContrastText(color.main);
    }

    return color;
}

export const createPalette = (color: PaletteColorOptions) => augmentColor(color);
